export default __webpack_public_path__ + "static/media/rating_10.14e13a21.svg";